import { AutogenLayoutMobileCommControlQuickInfo } from "./autogen/AutogenLayoutMobileCommControlQuickInfo";

/**
 * Mobile Communication Control Quick Info component
 * Displays read-only information about mobile communication control settings
 */
export class MobileCommControlQuickInfo extends AutogenLayoutMobileCommControlQuickInfo {

    async onLoad() {
        // Set up data display formatting
        this.setupDisplayFormatting();
    }

    /**
     * Set up display formatting for the quick info
     * Ensures all controls are in read-only mode for display purposes
     */
    private setupDisplayFormatting() {
        // Ensure switches are properly displayed but not editable
        this.switchMobileDispatchQI.enabled = false;
        this.switchCommunicationsQI.enabled = false;
        this.switchTrailerTrackingQI.enabled = false;
        this.switchReeferTrackingQI.enabled = false;
    }
}
